import { type RootState } from '../../stores/redux';

export const getCurrentStep = (state: RootState) =>
  state.callTroubleshooting.currentStep;

export const getIsTroubleshootingActive = (state: RootState) =>
  state.callTroubleshooting.currentStep !== null;
